import { Link, useNavigate } from 'react-router-dom'
import styles from './access.module.css'
import GoBackIcon from '../../assets/svg/GoBackIcon'

const AccessDenied = ({ children, text, subText, btnText }) => {
    const navigate = useNavigate()
    return (
        <div
            className={`${styles.accessDeniedSection} d-flex flex-column align-items-center justify-content-center`}
        >
            {children}
            <h2 className={`${styles?.accessHeading}`}>{text}</h2>
            {subText && (
                <p className={`${styles.subText} my-4 text-center`}>
                    {subText}
                </p>
            )}
            {btnText && (
                <Link
                    onClick={() => navigate(-1)}
                    class="fs-6 text-decoration-none d-flex align-items-center"
                >
                    <GoBackIcon className={'me-2'} />
                    {btnText}
                </Link>
            )}
        </div>
    )
}

export default AccessDenied
